// Design System — IconButton constants
export const ICON_BUTTON_SIZES = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'];

// `dashed` is the component's own look — the circular dashed "add user" affordance.
// `plain` keeps only the glyph: no circle, border or control-size box, so a
// close/remove/toggle control adds nothing but its own positioning and colour.
export const ICON_BUTTON_VARIANT = { DASHED: 'dashed', PLAIN: 'plain' };
